import {NgClass} from "@angular/common";
import {Component, inject, input} from "@angular/core";
import {Router} from "@angular/router";

@Component({
  selector: 'app-big-button',
  imports: [
    NgClass
  ],
  host: {'class': 'flex-auto height-50px'},
  templateUrl: './big-button.component.html',
  styleUrl: './big-button.component.css'
})
export class BigButton {

  disabled = input(false);
  url = input.required<string>();

  private router = inject(Router);

  navigate() {
    if (this.disabled()) return;

    this.router.navigate([this.url()]);
  }
}
